import React, { useEffect, useState } from 'react';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import { getProductParameterWarnings } from '../../Reducers/App/Selectors';
import { setProductParameterWarningsApproved, toNextStep } from '../../Reducers/App/Actions';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  list: {
    paddingLeft: 16,
    '& > li': {
      listStyleType: '"- "',
    },
  },
});

export const ProductParameterWarningDialog = () => {
  const warnings = useSelector(getProductParameterWarnings);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    warnings?.length && setOpen(true);
  }, [warnings]);

  const dispatch = useDispatch();

  const classes = useStyles();

  const close = () => setOpen(false);

  const closeAndContinue = () => {
    close();
    dispatch(setProductParameterWarningsApproved());
    dispatch(toNextStep());
  };

  return (
    <CustomDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t('productParameterWarnings.title')}
      onCancel={close}
    >
      <DialogContent>
        <ul className={classes.list}>
          {warnings.map(({ errorMessage }) => (
            <li key={errorMessage}>{t(errorMessage)}</li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <MainButton onClick={closeAndContinue}>{t('productParameterWarnings.okButtonLabel')}</MainButton>
      </DialogActions>
    </CustomDialog>
  );
};
